import React from "react";

const VegetableSection = () => {
  return (
    <section className="bg-green-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-green-800 mb-4">
            Vegetable Distributor
          </h2>
          <p className="text-xl text-green-700 max-w-3xl mx-auto">
            We are Freshigo Vegetables. We  export the very finest and freshest vegetables from over 18 countries all year round.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-start">
            {/* Left Column - Description */}
            <div>
              <p className="text-gray-700 leading-relaxed mb-6">
                For many years, we have proudly served as a trusted supplier to retailers and wholesalers in various markets. However, our role extends beyond simply exporting and distributing vegetables. We cultivate lasting partnerships with growers and clients alike, built on trust and mutual growth. This commitment makes us the perfect vegetable partner for today and tomorrow.
              </p>

              {/* Our Specialties - Kunru, Tamater, Dhaniya */}
              <div className="mt-8 mb-8">
                <h3 className="text-lg font-semibold text-green-600 mb-4 flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                  </svg>
                  Our Specialties
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {/* Kunru (Ivy Gourd) */}
                  <div className="bg-green-50 p-3 rounded-lg border border-green-200 flex items-center space-x-3">
                    <div className="bg-green-100 p-2 rounded-full">
                      <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-medium text-gray-800">Ivy Gourd</p>
                    </div>
                  </div>

                  {/* Tamater (Tomato) */}
                  <div className="bg-green-50 p-3 rounded-lg border border-green-200 flex items-center space-x-3">
                    <div className="bg-green-100 p-2 rounded-full">
                      <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-medium text-gray-800">Fresh Tomatoes</p>
                    </div>
                  </div>

                  {/* Dhaniya (Coriander) */}
                  <div className="bg-green-50 p-3 rounded-lg border border-green-200 flex items-center space-x-3">
                    <div className="bg-green-100 p-2 rounded-full">
                      <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                    </div>
                    <div>
                      <p className="font-medium text-gray-800">Coriander Leaves</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Go directly to links */}
              <div className="mt-8">
                <p className="text-sm font-semibold text-green-600 uppercase tracking-wide mb-3">
                  Go directly to
                </p>
                <div className="flex flex-wrap gap-4">
                  <a
                    href="#products"
                    className="inline-flex items-center px-6 py-3 bg-green-600 text-white font-medium rounded-md hover:bg-green-700 transition shadow-md"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                    </svg>
                    Our Products
                  </a>
                  <a
                    href="#about"
                    className="inline-flex items-center px-6 py-3 bg-green-100 text-green-700 font-medium rounded-md hover:bg-green-200 transition shadow-sm"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    About Us
                  </a>
                </div>
              </div>
            </div>

            {/* Right Column - Images from public folder */}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              <img
                src="/image1.png"
                alt="Fresh vegetables"
                className="w-full h-32 object-cover rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
              />
              <img
                src="/image2.png"
                alt="Vegetable farming"
                className="w-full h-32 object-cover rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
              />
              <img
                src="/image3.png"
                alt="Vegetable distribution"
                className="w-full h-32 object-cover rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 col-span-2 md:col-span-1"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VegetableSection;